import initialState from '../../data/trending';
import ActionTypes from '../constants/action-types';

const trendingReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.SET_TRENDING:
            if (state.users && state.users.length > 0) {
                let tmp = [...state.users];
                const userIDs = new Set(tmp.map(user => user.id));
                tmp = [...tmp, ...action.payload.filter(u => !userIDs.has(u.id))];

                return {
                    ...state,
                    users: tmp
                };
            }

            return {
                ...state,
                users: action.payload
            };
        case ActionTypes.SET_TRENDING_KEYWORD:
            return {
                ...state,
                keyword: action.payload
            };
        case ActionTypes.RESET_TRENDINGS:
            return {
                ...state,
                users: []
            };
        case ActionTypes.SET_TRENDINGS_BUSY:
            return {
                ...state,
                busy: action.payload
            };
        case ActionTypes.SET_TRENDINGS_TOTAL:
            return {
                ...state,
                total: action.payload
            };

        case ActionTypes.NO_RELOAD_UPDATE_TRENDINGS:
            let tmp = [...state.users];
            let updatedData = action.payload;
            const index = tmp.findIndex(pu => pu.id == updatedData.id);
            
            if(index >= 0) {
                const status = tmp[index].status;
                updatedData.status = status;
                tmp.splice(index, 1, updatedData);
            }

            return {
                ...state,
                users: tmp
            };

        default: return state;
    }
};

export default trendingReducer;
